<template>
  <div>
    <el-dialog
      class="check-dialog"
      :title="title"
      ref="ruleForm"
      :visible.sync="dialogFormVisible"
      @close="editCallback"
    >

     <div class="content" v-if="customerCheck">
        <div v-for="(item, i) in renderList" :key="i">
          <div class="con-title">
            <span>{{ item.title }}</span>
          </div>
          <div class="form-content" v-if="i==0">
            <div class="cont-item" v-for="(d, j) in item.data" :key="j">
              <div class="cont-name">{{ d.title }} ：</div>
              <div class="cont-info">{{ (d.formatter && d.formatter(data,null,data[d.name])) || data[d.name] || '--'}}</div>
            </div>
          </div>
           <div class="form-content" v-show="i!==0" v-for="(x, y) in data1" :key="y">
             <div class="CustomerTitle">成员{{y+1}}</div>
            <div class="cont-item" v-for="(d, j) in item.data" :key="j">
                <div>
                  <div class="cont-name">{{ d.title }} ：</div>
                  <div class="cont-info">{{ (d.formatter && d.formatter(x,null,x[d.name])) || x[d.name] || '--'}}</div>
              </div>
            </div>
          </div>
          </div>
      </div>

      <div class="content" v-else>
        <div v-for="(item, i) in renderList" :key="i">
          <div class="con-title">
            <span>{{ item.title }}</span>
          </div>
          <div class="form-content">
            <div class="cont-item" v-for="(d, j) in item.data" :key="j" :class="d.class">
              <div v-if="d.type == 'image'">
                <div class="cont-name">{{ d.title }} ：</div>
                <img :src="(d.formatter && d.formatter(null,null,data[d.name]))||data[d.name]" alt="">
              </div>
              <div v-else>
                <div class="cont-name">{{ d.title }} ：</div>
                <div class="cont-info">{{ (d.formatter && d.formatter(data,null,data[d.name])) || data[d.name] || '--'}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" size="small" @click="editCallback()"
          >关闭</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
/**
 *
 * props 参数buttons
 * eventKey:通过key在回调中处理按钮事件 type:按钮样式类型 checkSubmit:是否需要绑定提交指令
 * 例：{ label: "确定", eventKey: "submit", type: "primary" ,checkSubmit:true},
 * props 参数 Array:renderList
 * [{title:'连锁店信息',data:[{name:'name',title:'名称'}]}]
 */
export default {
  name: "CheckDialog",
  props: {
    buttons: {
      type: Array,
      default: () => [
        { label: "取消", eventKey: "cancel" },
        {
          label: "确定",
          eventKey: "submit",
          type: "primary",
          checkSubmit: true,
        },
      ],
    },
    title: {
      type: String,
      default: "查看弹窗",
    },
    checkVisible: {
      type: Boolean,
      required: true,
    },
     customerCheck: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    data1: {
      type: Array,
      default: () => [],
    },
    renderList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialogFormVisible: this.checkVisible,
    };
  },
  methods: {
    editCallback() {
      this.$emit("update:checkVisible", false);
    },
  },
  created() {},
};
</script>
<style lang='scss' scoped>
.CustomerTitle{
  color: #000;
  text-align: left;
  padding-left: 140px;
  margin-bottom: 15px;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
.con-title {
  text-align: left;
  margin-bottom:10px;
  span {
    border-bottom: 2px #409eff solid;
    line-height: 30px;
    padding: 5px 0;
  }
}
.form-content {
  padding-left:30px;
  margin-bottom:10px;
}
.cont-item {
  height: 40px;
  line-height: 40px;
  .cont-name {
    float: left;
    margin-right: 20px;
    width: 120px;
    text-align: left;
  }
  .cont-info {
    float: left;
  }
}
.idCard {
  height: 200px!important;
  img{
    border: 1px #ddd dashed;
  background: #def5ff66;
    width: 380px;
    height: 180px;
    float: left;
  }
}
.avatar{
   height: 200px!important;
  img{
    width: 180px;
    border: 1px #ddd dashed;
  background: #def5ff66;
    height: 180px;
    float: left;
  }
}
</style>
<style>
.check-dialog .el-dialog {
  width: 50%;
  max-width: 700px;
}
.check-dialog .el-dialog__header {
  display: none;
}

</style>


// WEBPACK FOOTER //
// src/components/common/page/CheckDialog.vue